import { DeviceLocationList } from './DeviceLocationList';
import { DeviceLocationShow } from './DeviceLocationShow';

export const list = DeviceLocationList;
export const show = DeviceLocationShow;
